import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Grid } from '@mui/material';
import {vector_layer_list} from './Const'
import { setVectorLayer } from '../../../redux/actions/mapaction';
import { useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import { bgColors } from '../../utils/bgColor';
import Divider from '@mui/material/Divider';


export default function VectorLayerSwitch() {

  const dispatch = useDispatch()

  const initialState = {
    State:false,
    District:false,
    Subdistrict:false,
    Village:false,
    Pincode:false,
    Surveypolygons: false,
    WaterBodies: false,
    Labels: false,
    Navlayer:false,
    ElevationLayer:false,
    Userproject:false
  }
  const [state, setState] = React.useState(
    initialState
  );

  const handleChange = (event) => {
    event.preventDefault()
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    dispatch(setVectorLayer({
      ...state,
      [event.target.name]: event.target.checked,
    }))

  };

  return (
    <FormControl component="fieldset" variant="standard">
      <Grid container spacing={1} display='flex' padding={5}>
      <FormGroup>
        {vector_layer_list.map((item,index) => 
          <FormControlLabel key = {`${item}_${index}_form`}
            control={
              <Switch key = {`${item}_${index}_switch`} size='medium' checked={state.item} onChange={handleChange} name={item} />
            }
            label={

              <Typography   sx ={{
                fontSize: 14, 
                 fontFamily:'serif',
                 padding:'0.25rem',
                 color:bgColors.grey_800
                 }}>  {item} </Typography>
            }
          />
        )
        }
      </FormGroup>
      </Grid>
    </FormControl>
  );
}